import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getAvailabilityStoresSelector } from '@redux/reducers/bopis/getAvailabilityStores/selector';
import { ASSEMBLE_OPTION_KEY } from '@utils/constant';

import { getAddedAODProductsSelector } from '../../../../redux/reducers/buyingOption/BOAddOnDeal/selector';

export const useCheckBOPISAvailable = () => {
  const boGetDataStatusReducer = useSelector((state) => state.buyingOptionReducer.BOGetDataStatusReducer);
  const boVariantsReducer = useSelector((state) => state.buyingOptionReducer.BOVariantsReducer);
  const tradeInSelected = useSelector((state) => state.buyingOptionReducer.BOTradeInReducer?.tradeInActive?.selectedTradeInProduct);
  const freeGiftsList = useSelector(state => state.buyingOptionReducer.BOFreeGiftsReducer.freeGiftsList) || [];

  const freeGiftsSelectedID = useSelector(state => state.buyingOptionReducer.BOFreeGiftsReducer.freeGiftsSelectedID)
    || [];
  const additionalOptionsActive = useSelector(state => state.buyingOptionReducer.BOAdditionalOptionsReducer.additionalOptionsActive);
  const currentCart = useSelector(state => state.productReducer.cartDetailReducer.currentCart);
  const { data: bopisStoresList } = useSelector(getAvailabilityStoresSelector);
  const productDetailData = useSelector(state => state.buyingOptionReducer.BOGetDataStatusReducer);

  const additionalOptionsList = useSelector(state => state.buyingOptionReducer.BOAdditionalOptionsReducer.additionalOptionsList)
    || [];
  const addOnDealProductsList = useSelector(getAddedAODProductsSelector);

  const isFreeGiftSelectedHasBOPISOption = useMemo(
    () => freeGiftsSelectedID.length ? freeGiftsSelectedID.every((item) => item.HasBOPISOption) : true,
    [freeGiftsSelectedID]
  );

  const isAODSelectedHasBOPISOption = useMemo(() => {
    return addOnDealProductsList?.length ? addOnDealProductsList.every((product) => product.HasBOPISOption) : true;
  }, [JSON.stringify(addOnDealProductsList)]);

  const isShowStoresList = useMemo(
    () => {
      const isHasGiftOptions = !productDetailData?.productId
        ? currentCart?.Lines?.some(line => line.GiftingOptionLines?.length)
        : false;

      return bopisStoresList.length && !tradeInSelected && !(
        ASSEMBLE_OPTION_KEY in additionalOptionsActive
      ) && !isHasGiftOptions && isFreeGiftSelectedHasBOPISOption && isAODSelectedHasBOPISOption;
    },
    [
      bopisStoresList,
      tradeInSelected,
      additionalOptionsActive,
      currentCart,
      JSON.stringify(freeGiftsSelectedID),
      isFreeGiftSelectedHasBOPISOption,
      JSON.stringify(productDetailData),
      isAODSelectedHasBOPISOption
    ]
  );

  const handleCheckIsEnableBOPISOption = useCallback(
    /** @param  {Boolean} [isRequiredAssemblyOption] - isRequiredAssemblyOption is an optional param */
    (isRequiredAssemblyOption) => boGetDataStatusReducer?.HasBOPISOption
      && boVariantsReducer?.variantList?.length
      && !tradeInSelected && (
        (
          typeof isRequiredAssemblyOption !== 'undefined' && additionalOptionsList?.[ASSEMBLE_OPTION_KEY]
        ) ? !isRequiredAssemblyOption : true
      ) && (
        !freeGiftsList.length || (
          freeGiftsList.length && isFreeGiftSelectedHasBOPISOption
        )
      ) && isAODSelectedHasBOPISOption,
    [
      boGetDataStatusReducer,
      boVariantsReducer,
      tradeInSelected,
      freeGiftsList,
      JSON.stringify(freeGiftsSelectedID),
      additionalOptionsList,
      isAODSelectedHasBOPISOption
    ]
  );

  return useCallback(
    /** @param  {Boolean} [isRequiredAssemblyOption] - isRequiredAssemblyOption is an optional param */
    (isRequiredAssemblyOption) => (
      {
        isEnableBOPISOption: handleCheckIsEnableBOPISOption(isRequiredAssemblyOption),
        isShowStoresList
      }
    ), [isShowStoresList, handleCheckIsEnableBOPISOption]);
};